import { render, staticRenderFns } from "./FlexHIcon.vue?vue&type=template&id=bc94071c&"
import script from "./FlexHIcon.vue?vue&type=script&lang=js&"
export * from "./FlexHIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports